<template>
	<div class="page">
		<!-- your page -->
		<Head></Head>
		<div class="evaluate">
			<div class="fixation">
				<div class="line" v-for="(item,index) in list" :key="index">
					<div class="info">
						<div class="avatar">
							<img :src="item.info.avatar" alt="">
						</div>
						<div class="pro">
							<div class="name">
								{{item.info.name}}
							</div>
							<div class="price">
								¥{{item.info.price}}
							</div>
						</div>
					</div>
					<div class="content">
						<div class="title">请输入评论</div>
						<div class="inputBox">
							<textarea name="" v-model="item.content"></textarea>
						</div>
					</div>
					<div class="upload">
						<div class="imgItem" v-for="(tab,tabIndex) in item['img']" :key="tabIndex"><img :src="tab.url" alt=""><div class="delete" @click="deleteThisImg"><img :data-id="tab.id" :data-fid="item.id" src="../../assets/index/close.png" alt=""></div></div>
						<div class="uploadBtn"><img src="../../assets/person/upload.jpg" alt="" @click="clickUpload" :data-id="item.id"><input type="file" accept="image/*" @change="handleFile" class="hideInput"></div>
					</div>
					<div class="score">
						<div class="title">
							请点击评分
						</div>
						<div class="scoreBox">
							<div class="scoreItem" v-for="(tab,tabIndex) in item['star']" :key="tabIndex" :data-id="item.id" @click="getScore"><img :src="tab.star" alt="" :data-id="item.id" :data-score="tab.id"></div>
						</div>
					</div>
				</div>
				<div class="enter">
					<button @click="enter">确认评价</button>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	// your script
	export default {
		name: 'refund',
		components:{
			Head,Foot
		},
		data(){
			return {
				list:[]
			}
		},
		methods:{
			deleteThisImg(e){
				var fid = e.target.dataset.fid
				var id = e.target.dataset.id
				var list = this.list
				for (var i = 0; i < list.length; i++) {
					var lid = list[i].id
					if(fid==lid){
						for (let k in list[i].img) {
							var kid = list[i].img[k].id
							if(id==kid){
								list[i].img.splice(k,1)
							}
						}
					}
				}
				this.list = list
			},
			enter(){
				var list = this.list
				var array = new Array()
				var data = {
					order_id:this.oid,
					method:"user.orderevaluate",
					token:this.token,
					items:{}
				}
				for (var i = 0; i < list.length; i++) {
					array.push(list[i].id)
				}
				for (var i = 0; i < array.length; i++) {
					var obj = {
						textarea:list[i].content,
						score:list[i].score,
						images:list[i].img
					}
					data['items'][array[i]] = obj
				}
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.globalTest('user.orderevaluate','success','提交评论成功')
						that.$router.push({path:'/person/order',query:{mid:1}})
					}else{
						that.globalTest('user.orderevaluate','error',res.msg,res.data)
					}
				})
			},
			getScore(e){
				var id = e.target.dataset.id
				var score = e.target.dataset.score
				var list = this.list
				for (var i = 0; i < list.length; i++) {
					var lid = list[i].id
					if(id==lid){
						for (var k = 0; k < list[i].star.length; k++) {
							var sid = list[i].star[k].id
							if(sid<=score){
								list[i].star[k].star = require("../../assets/person/ystar.png")
							}else{
								list[i].star[k].star = require("../../assets/person/star.png")
							}
						}
						list[i].score = score
					}
				}
				this.list = list
			},
			clickUpload(e){
				this.uid = e.target.dataset.id
				this.$el.querySelector('.hideInput').click()
			},
			handleFile(e){
				var uid = this.uid
				var list = this.list
				var imglist = function(){
					for (var i = 0; i < list.length; i++) {
						var lid = list[i].id
						if(uid==lid){
							return list[i].img
						}
					}
				}
				if(imglist().length>=3){
					this.globalTest('images.upload','error','最多只能上传3张')
					return
				}
				let $target = e.target || e.srcElement
				let file = $target.files[0]
				var token = this.token
				var formData = new FormData()
				formData.append('image',file,file.name)
				formData.append('method','images.upload')
				formData.append('type','image')
				formData.append('token',token)
				var that = this
				this.uploadFile(formData,function(res){
					console.log(res)
					if(res.status){
						for (var i = 0; i < list.length; i++) {
							var lid = list[i].id
							if(uid==lid){
								var obj = {
									id:res.data.image_id,
									url:res.data.url
								}
								list[i].img.push(obj)
							}
						}
					}else{
						that.globalTest('images.upload','error',res.msg,res.data)
					}
				})
			},
			fetchData(){
				var data = {
					method: "order.details",
					order_id: this.oid,
					token: this.token
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						var relist = res.data.items
						for (var i = 0; i < relist.length; i++) {
							var item = relist[i]
							var obj = {
								info:{
									"avatar":item.image_url,
									"name":item.name,
									"price":item.price,
								},
								img:[],
								content:"",
								star:[
									{"id":1,star:require("../../assets/person/star.png")},
									{"id":2,star:require("../../assets/person/star.png")},
									{"id":3,star:require("../../assets/person/star.png")},
									{"id":4,star:require("../../assets/person/star.png")},
									{"id":5,star:require("../../assets/person/star.png")}
								],
								id:item.id
							}
							that.list.push(obj)
						}
					}else{
						that.globalTest('order.details','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.oid = this.$route.query.oid
			this.token = localStorage.getItem('token')
			var that = this
			this.ids = this.$qs.parse(that.$route.query.ids)
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.evaluate{
		width: 100%;
	}
	.fixation{
		background: #FFFFFF;
		padding: 50px;
		box-sizing: border-box;
	}
	.line{
		width: 100%;
		height: 475px;
		border-bottom: 1px solid #C3C3C3;
	}
	.info{
		width: 100%;
		height: 100px;
	}
	.info .avatar{
		width: 120px;
		height: 100%;
		float: left;
	}
	.info .avatar img{
		width: 90px;
		height: 90px;
		display: block;
		margin: 5px auto;
	}
	.pro{
		width: 980px;
		height: 100%;
		float: left;
	}
	.pro .name{
		width: 100%;
		height: 72px;
		line-height: 24px;
	}
	.pro .price{
		width: 100%;
		height: 28px;
		line-height: 28px;
		color: red;
	}
	.content,.upload,.score{
		width: 100%;
		margin-top: 15px;
		position: relative;
	}
	.upload{
		font-size: 0px;
		letter-spacing: -6px;
	}
	.imgItem,.uploadBtn{
		width: 150px;
		height: 120px;
		margin-top: 10px;
		display: inline-block;
		vertical-align: top;
		letter-spacing: normal;
		position: relative;
	}
	.imgItem img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.imgItem .delete{
		width: 16px;
		height: 16px;
		position: absolute;
		right: 0px;
		top: 0px;
		z-index: 9;
	}
	.imgItem .delete img{
		width: 100%;
		height: 100%;
	}
	.uploadBtn input{
		display: block;
		opacity: 0;
		width: 100%;
		height: 100%;
		left: 0px;
		top: 0px;
		z-index: 9;
		position: absolute;
		background: #0053B8;
		display: none;
	}
	.title{
		width: 120px;
		height: 30px;
		position: absolute;
		left: 0px;
		top: 0px;
		line-height: 30px;
		font-size: 14px;
	}
	.inputBox,.scoreBox{
		width: 100%;
		padding-left: 120px;
		box-sizing: border-box;
	}
	.inputBox{
		height: 150px;
	}
	.inputBox textarea{
		width: 700px;
		height: 100%;
		display: block;
		box-sizing: border-box;
	}
	.scoreBox{
		height: 50px;
	}
	.scoreBox .scoreItem{
		width: 30px;
		height: 100%;
		float: left;
	}
	.scoreItem img{
		width: 20px;
		height: 20px;
		display: block;
		margin: 5px auto;
	}
	.enter{
		width: 100%;
		height: 80px;
		padding-top: 40px;
	}
	.enter button{
		width: 150px;
		height: 40px;
		color: #FFFFFF;
		background: #036DEE;
		border: none;
	}
</style>
